import { State } from 'src/types'
import { webTop, webBottom } from 'src/features/brands/ragdelion/canvas/firstmitt/rightThrow/back/web'
import { catchFace } from 'src/features/brands/ragdelion/canvas/firstmitt/rightThrow/back/catchFace'
import { backAroundWeb } from 'src/features/brands/ragdelion/canvas/firstmitt/rightThrow/back/backAroundWeb'
import { stitch } from 'src/features/brands/ragdelion/canvas/firstmitt/rightThrow/back/stitch'
import { backOfIndexToLittle } from 'src/features/brands/ragdelion/canvas/firstmitt/rightThrow/back/backOfIndexToLittle'
import { boomerang } from 'src/features/brands/ragdelion/canvas/firstmitt/rightThrow/back/boomerang'
import { littleHook } from 'src/features/brands/ragdelion/canvas/firstmitt/rightThrow/back/littleHook'
import { liningLeather } from 'src/features/brands/ragdelion/canvas/firstmitt/rightThrow/back/liningLeather'
import { thumbHook } from 'src/features/brands/ragdelion/canvas/firstmitt/rightThrow/back/thumbHook'
import { laces } from 'src/features/brands/ragdelion/canvas/firstmitt/rightThrow/back/lace'
import { ragdelionEngravedOfBackFace, ragdelionLabel } from 'src/features/brands/ragdelion/canvas/labels/ragdelion'
import { loopOfRingFinger } from 'src/features/brands/ragdelion/canvas/glove/rightThrow/back/loopOfRingFinger'
import { fingerGuardDrawer } from 'src/features/brands/ragdelion/canvas/firstmitt/rightThrow/back/fingerGuardDrawer'
import { edgeDrawer } from 'src/features/brands/ragdelion/canvas/firstmitt/rightThrow/back/edgeDrawer'
import { backOfThumbDrawer } from 'src/features/brands/ragdelion/canvas/firstmitt/rightThrow/back/thumbDrawer'
import { wristBeltDrawer } from 'src/features/brands/ragdelion/canvas/firstmitt/rightThrow/back/wristBeltDrawer'
import { liningEmbroidery, ragLionEmbroidery } from 'src/features/brands/ragdelion/canvas/common/back/embroidery'
import { canvasResetter } from 'src/features/brands/ragdelion/canvas/common/canvasResetter'
import { bottomRightOfBeltEmbroideryDrawer } from 'src/features/brands/ragdelion/canvas/common/back/useCanvasEmbroideries'
import { firstMittChildFingerEmbroideryLeftThrow, startInversion, thumbEmbroideryDrawerLeftThrow, undoInversion } from 'src/util/canvas'

export const ragdelionCanvasFirstMittBackLeftThrow = (ctx: CanvasRenderingContext2D, state: State, canvasWidth: number): void => {
  if (!state.boomerang) return
  if (!state.thumb) return
  if (!state.underWeb) return
  // リセット
  canvasResetter(ctx)
  startInversion(ctx, canvasWidth)
  // 裏革
  liningLeather(ctx, state.linings.color)
  undoInversion(ctx, canvasWidth)
  // ragdelionライオン描画
  ragLionEmbroidery(ctx, state.ragLionLogo.value, state.ragLionLogoColor.color, 15, 60)

  const isEmbroideryOfLining = state.embroideries.some((x) => x.position.value === 'leatherLiningFirst')
  // 平裏への刺繍
  if (isEmbroideryOfLining) {
    liningEmbroidery(
      ctx,
      state.embroideries.find((e) => e.position.value === 'leatherLiningFirst'),
      200,
      -65
    )
  }

  const isEmbroideryOfLiningSecond = state.embroideries.some((x) => x.position.value === 'leatherLiningSecond')
  // 平裏への刺繍
  if (isEmbroideryOfLiningSecond) {
    liningEmbroidery(
      ctx,
      state.embroideries.find((e) => e.position.value === 'leatherLiningSecond'),
      205,
      -25
    )
  }

  startInversion(ctx, canvasWidth)
  if (state.loopOfRingFinger?.value === 'loopOfRingFinger') {
    loopOfRingFinger(ctx, state?.loopOfRingFingerColor?.color, state.stitch.color)
  }

  // 捕球面
  catchFace(ctx, state.catchFace.color)
  // ウェブ先端側
  webTop(ctx, state.web.color)
  // ウェブ捕球面側
  webBottom(ctx, state.web.color)
  // ブーメラン部分
  boomerang(ctx, state.boomerang.color) // 専用のstateを設けて適用
  // 背面＿人差し指-小指
  backOfIndexToLittle(ctx, state.boomerang.color) // 専用のstateを設けて適用

  undoInversion(ctx, canvasWidth)
  // 小指への刺繍
  const isEmbroideryOfChild = state.embroideries.some((x) => x.position.value === 'pinkyFingerSideBack')
  if (isEmbroideryOfChild) {
    firstMittChildFingerEmbroideryLeftThrow(
      ctx,
      state.embroideries.find((embroidery) => embroidery.position.value === 'pinkyFingerSideBack'),
      890,
      -440
    )
  }

  startInversion(ctx, canvasWidth)
  // 背面＿親指_
  backOfThumbDrawer(ctx, state.thumb.color, state.stitch.color)
  // 手首ベルト
  wristBeltDrawer(ctx, state)

  undoInversion(ctx, canvasWidth)
  // RAG de Lion のみ＿ベルト右下への刺繍
  bottomRightOfBeltEmbroideryDrawer(ctx, state.embroideries, 60, 35)

  startInversion(ctx, canvasWidth)
  // 小指掛け紐
  littleHook(ctx, state.littleHook.color)
  // 親指掛け紐
  thumbHook(ctx, state.thumbHook.color)

  undoInversion(ctx, canvasWidth)
  // 親指への刺繍
  const isEmbroideryOfThumb = state.embroideries.some((x) => x.position.value === 'thumbFinger')
  if (isEmbroideryOfThumb) {
    thumbEmbroideryDrawerLeftThrow(
      ctx,
      state.embroideries.filter((embroidery) => embroidery.position.value === 'thumbFinger'),
      state.backStyle
    )
  }

  startInversion(ctx, canvasWidth)
  // 背面＿ウェブ周り
  backAroundWeb(ctx, state.underWeb.color)
  // ヘリ革
  edgeDrawer(ctx, state)
  // ステッチ
  stitch(ctx, state.stitch.color)
  // 指カバー
  fingerGuardDrawer(ctx, state.fingerGuardType.value, state.indexCover.color, state.stitch.color, state.fingerGuardPosition.value)

  undoInversion(ctx, canvasWidth)
  // ラベル
  switch (state.labelPosition.value) {
    case 'onBelt':
      ragdelionLabel(ctx, state.ragLabel.value, 65, 25, 0, 1)
      break
    case 'byThumb':
      ragdelionLabel(ctx, state.ragLabel.value, 290, -520, 55, 0.85)
      ragdelionEngravedOfBackFace(ctx, state.catchFace.value, 70, 35)
      break
  }
  startInversion(ctx, canvasWidth)
  // 革紐
  laces(ctx, state.lace.color)
  undoInversion(ctx, canvasWidth)
}
